export function base64ToArrayBuffer(dataURI) {
    const binaryString = atob(dataURI.split(',')[1]);
    const ab = new ArrayBuffer(binaryString.length);
    const bytes = new Uint8Array(ab);
    for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
    }
    return bytes.buffer;
}
export function removeItemWithId(array, idToFind) {
    const ids = Array.isArray(idToFind) ? idToFind : [idToFind];
    return array.filter(({ id }) => !ids.includes(id));
}
export function distinctArrayById(arr) {
    const newArray = [];
    for (const item of arr) {
        const itemExists = newArray.some(a => a.id === item.id);
        if (!itemExists) {
            newArray.push(item);
        }
    }
    return newArray;
}
export function isUnique(value, index, self) {
    return self.indexOf(value) === index;
}
export function arrayToMap(array) {
    return array.reduce((map, item) => map.set(item.id, item), new Map());
}
export function arrayToRecord(array) {
    return array.reduce((record, item) => {
        record[item.id] = item;
        return record;
    }, {});
}
